import { Spinner } from '@fluentui/react';

import AnalyticsBlock from '../AnalyticsBlock';
import useEmployeeStatsData from '../functions/useEmployeeStatsData';

export default () => {
  const stats = useEmployeeStatsData();

  if (!stats) {
    return <Spinner />;
  }

  const { employeeSummaries: summaries, retailNames } = stats;

  const retailNamesReverse = Object.fromEntries(
    Object.entries(retailNames).map((a) => a.reverse())
  );
  const retails = Object.values(retailNames);
  const employees = Object.keys(summaries);
  const data = [
    ["Mağaza", "Ciro"],
    ...retails.map((retail) => [
      retail,
      employees.reduce(
        (total, employee) =>
          total +
          (summaries[employee][retailNamesReverse[retail]]?.grandTotal || 0),
        0
      ),
    ]),
  ];

  return (
    <AnalyticsBlock
      Title="Toplam Mağaza Cirosu"
      ChartProps={{
        chartType: "PieChart",
        data,
      }}
    />
  );
};
